<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('ADD_KNOWLEDGE_FOLDER.EDIT_TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      //- Folder Name
      v-row.mt-4
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE_FOLDER.NAME')}}
        v-col.pa-0(cols='9')
          v-text-field(
            v-model='addFolderData.name'
            outlined
            dense
            :rules='formRule.nameRules'
            required='required'
          )
      //- Parent
      v-row
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE_FOLDER.PATH')}}
        v-col.pa-0(cols='8')
          v-text-field(
            v-model='addFolderData.path'
            outlined
            dense
            :rules='formRule.parentRules'
            required='required'
            readonly
            @click='openFolderPick'
          )
        v-col.pa-0(cols='1')
          v-btn.pa-0(plain ripple style='width:40px; height:28px;' @click='openFolderPick')
            v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="30" max-width="30")
      v-divider
      //- Permission Setting
      v-row.mt-2
        v-col.d-flex.flex-nowrap.pa-0(cols='12')
          div(style='color:#222222; font-weight: 700; font-size: 16px;') {{$t("ADD_KNOWLEDGE_FOLDER.PERMISSION_SETTING")}}
      v-row.mt-2(no-gutters='no-gutters' align="start")
        v-col(cols='12' md='12').pr-2
          .knowledges-detail-card-text.pt-0
            v-card-text.mt-0.pa-0.knowledges-card-text()
              v-row(no-gutters).mt-2
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('KB_AND_BOT_PERMISSION_SETTING.MANAGER')}}
                v-col.pa-0(cols='9')
                  v-radio-group.ma-0.d-flex(
                    v-model='default_manager_access_option'
                    row
                    mandatory
                    dense
                    :hide-details='true'
                    :readonly='addBtn_loading'
                    @change='toggleManagerAccessOption'
                  )
                    v-radio(:label=`$t('ADD_KNOWLEDGE_FOLDER.ONLY_SYSTEM_ADMIN')` color='#14C6DE' :value='true')
                    v-radio(:label=`$t('ADD_KNOWLEDGE_FOLDER.CUSTOM_SETTING')` color='#14C6DE' :value='false')
              //- Add User (Manager)
              v-row(no-gutters).mb-4
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;')
                v-col.pa-0(cols='9')
                  v-card.rounded-card.scrollselect
                    v-select.bg-white.pa-0.pl-2(
                      placeholder='Add User'
                      v-model='MUData'
                      return-object
                      multiple
                      chips
                      hide-details
                      :readonly="addBtn_loading || default_manager_access_option"
                      :items='user_list'
                      item-value='id'
                      item-text='name'
                    )
                      template(v-slot:prepend-inner)
                        v-img(src="@/assets/images/user_icon.png" height="20" width="20" style="margin-top:6px;")
                      template(v-slot:prepend-item)
                        v-list-item(ripple @mousedown.prevent @click="toggle('MU')")
                          v-list-item-action
                            v-icon(:color="user_list.length > 0 ? '#14C6DE' : ''") {{ icon(MUData, user_list) }}
                          v-list-item-content
                            v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                        v-divider(class="mt-2")
                      template(v-slot:selection="{ item, index }")
                        v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                          span.ellipsis-single {{ item.name }}
              //- Add Group (Manager)
              v-row(no-gutters).mt-2.mb-2
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;')
                v-col.pa-0(cols='9')
                  v-card.rounded-card.scrollselect
                    v-select.bg-white.pa-0.pl-2(
                      placeholder="Add Group"
                      v-model='MGData'
                      return-object
                      multiple
                      chips
                      hide-details
                      :readonly="addBtn_loading || default_manager_access_option"
                      :items='upgpt_group_list'
                      item-value='id'
                      item-text='name'
                    )
                      template(v-slot:prepend-inner)
                        v-img(src="@/assets/images/group_icon.png" height="20" width="20" style="margin-top:6px;")
                      template(v-slot:prepend-item)
                        v-list-item(ripple @mousedown.prevent @click="toggle('MG')")
                          v-list-item-action
                            v-icon(:color="upgpt_group_list.length > 0 ? '#14C6DE' : ''") {{ icon(MGData, upgpt_group_list) }}
                          v-list-item-content
                            v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                        v-divider(class="mt-2")
                      template(v-slot:selection="{ item, index }")
                        v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                          span.ellipsis-single {{ item.name }}
      v-row.mt-2(no-gutters='no-gutters' align="start")
        v-col(cols='12' md='12').pr-2
          .knowledges-detail-card-text.pt-0.pb-3
            v-card-text.mt-0.pa-0.knowledges-card-text()
              v-row(no-gutters).mt-2
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('KB_AND_BOT_PERMISSION_SETTING.VIEWER')}}
                v-col.pa-0(cols='9')
                  v-radio-group.ma-0.d-flex(
                    v-model='default_viewer_access_option'
                    row
                    mandatory
                    dense
                    :hide-details='true'
                    :readonly='addBtn_loading'
                    @change='toggleViewerAccessOption'
                  )
                    v-radio(:label=`$t('ADD_KNOWLEDGE_FOLDER.ONLY_SYSTEM_VIEWER')` color='#14C6DE' :value='true')
                    v-radio(:label=`$t('ADD_KNOWLEDGE_FOLDER.CUSTOM_SETTING')` color='#14C6DE' :value='false')
              //- Add User (Manager)
              v-row(no-gutters).mb-4
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;')
                v-col.pa-0(cols='9')
                  v-card.rounded-card.scrollselect
                    v-select.bg-white.pa-0.pl-2(
                      placeholder='Add User'
                      v-model='VUData'
                      return-object
                      multiple
                      chips
                      hide-details
                      :readonly="addBtn_loading || default_viewer_access_option"
                      :items='user_list'
                      item-value='id'
                      item-text='name'
                    )
                      template(v-slot:prepend-inner)
                        v-img(src="@/assets/images/user_icon.png" height="20" width="20" style="margin-top:6px;")
                      template(v-slot:prepend-item)
                        v-list-item(ripple @mousedown.prevent @click="toggle('VU')")
                          v-list-item-action
                            v-icon(:color="user_list.length > 0 ? '#14C6DE' : ''") {{ icon(VUData, user_list) }}
                          v-list-item-content
                            v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                        v-divider(class="mt-2")
                      template(v-slot:selection="{ item, index }")
                        v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                          span.ellipsis-single {{ item.name }}
              //- Add Group (Manager)
              v-row(no-gutters).mt-2.mb-2
                v-col.pr-md-4(cols='3').my-1
                  label(style='color:#444444; font-weight: 700; font-size: 14px;')
                v-col.pa-0(cols='9')
                  v-card.rounded-card.scrollselect
                    v-select.bg-white.pa-0.pl-2(
                      placeholder='Add Group'
                      v-model='VGData'
                      return-object
                      multiple
                      chips
                      hide-details
                      :readonly="addBtn_loading || default_viewer_access_option"
                      :items='upgpt_group_list'
                      item-value='id'
                      item-text='name'
                    )
                      template(v-slot:prepend-inner)
                        v-img(src="@/assets/images/group_icon.png" height="20" width="20" style="margin-top:6px;")
                      template(v-slot:prepend-item)
                        v-list-item(ripple @mousedown.prevent @click="toggle('VG')")
                          v-list-item-action
                            v-icon(:color="upgpt_group_list.length > 0 ? '#14C6DE' : ''") {{ icon(VGData, upgpt_group_list) }}
                          v-list-item-content
                            v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                        v-divider(class="mt-2")
                      template(v-slot:selection="{ item, index }")
                        v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                          span.ellipsis-single {{ item.name }}
  //- Footer
  div.d-flex.align-center.justify-end(style='background-color: #f4f4f4;  height:60px;')
    v-btn.mr-4(
      :ripple="false"
      @click="cancelEdit"
      width="100"
      height="40"
      color="cancel"
      depressed
      outlined
      style='font-weight: 700;'
      :disabled="addBtn_loading"
    ) {{$t('GENERAL.CANCEL')}}
    v-btn.mr-6(
      :ripple="false"
      @click="onEdit"
      width="100"
      height="40"
      color="#14C6DE"
      depressed
      dark
      :disabled="addBtn_loading"
    )
      v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
      .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.CONFIRM')}}
  //- status dialogs
  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
  v-dialog(v-model='messageApplyDialog' width='360' content-class='statusDialog' v-if='messageApplyDialog')
    message-apply-dialog(@emitMessageDialog='onEmitMessageApplyDialog' :message='messageApply')
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='folderPickerDialog' width='680' @keydown.esc="onCancel" content-class='statusDialog' v-if='folderPickerDialog')
    folder-location-picker-dialog(:selected-id='addFolderData.parent_id' :selected-path='addFolderData.path' @confirm='onFolderPickerConfirm' @cancel='onFolderPickerCancel' v-model='folderPickerDialog')
</template>
<script>
import Vue from "vue";
import messageDialog from "@/components/Dialog/redirectDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import messageApplyDialog from "@/components/Dialog/messageApplyDialog.vue";
import i18n from "/common/plugins/vue-i18n.js";
import folderLocationPickerDialog from "@/components/GPT_Dialog/Knowledge/folderLocationPickerDialog";
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
import PersonalSettingService from "@/services/PersonalSettingService";
import PermissionService from "@/services/PermissionService";

export default Vue.extend({
  name: "editKnowledgeFolder",
  components: {
    messageDialog,
    errorDialog,
    folderLocationPickerDialog,
    messageApplyDialog
  },
  props: {
    folder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      addBtn_loading: false,
      addFolderData: {
        name: "",
        path: "",
        parent_id: null,
      },
      formRule: {
        nameRules: [
                (v) => !!v || i18n.t('RULE.RULE_R'),
                (v) => /^.{0,200}$/.test(v) || i18n.t('RULE.RULE_200'),
        ],
        parentRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
        ],
        system_nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => /^[a-zA-Z0-9_]+$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'), // 只能輸入英文字母和數字或底線
          (v) => (v.length <= 30) || i18n.t('RULE.RULE_30')  // 最多 30 個字
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/s.test(v) || i18n.t('RULE.RULE_100')
        ],
        categoryRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30')
        ],
      },
      user_list: [],
      upgpt_group_list: [],
      default_manager_access_option: true,
      default_viewer_access_option: true,
      MUData: [],
      MGData: [],
      VUData: [],
      VGData: [],
      // //- 取消更新時的復原值
      ori_manager_access_option:true,
      ori_viewer_access_option:true,
      originalMUData:[],
      originalMGData:[],
      originalVUData:[],
      originalVGData:[],
      //- Dialog
      messageDialog: false,
      message: "",
      errorDialog: false,
      errorMessage: "",
      folderPickerDialog: false,
      messageApplyDialog: false,
      messageApply: "",
    }
  },
  watch: {
    folder: {
      immediate: true,
      handler(f) {
        if (!f) return;
        this.addFolderData.name = f.name || "";
        this.addFolderData.path = f.path || f.name || "";
        this.addFolderData.parent_id = (f.parent_id !== undefined && f.parent_id !== null) ? f.parent_id : null;

        // Optional: keep current selections as baseline for cancel/compare if needed later
        this.ori_manager_access_option = this.default_manager_access_option;
        this.ori_viewer_access_option = this.default_viewer_access_option;
      },
    },
  },
  async created() {
    this.loading = true;
    await this.getUserListData();
    await this.getUpGPTGroupListData();
    await this.getPermissionData();
    this.loading = false;
  },
  methods: {
    async getUserListData(){
                await PersonalSettingService.getUpGPTUserDetail().then(response => {
                    if (response.data.userList.length > 0) {
                        let temp_arr = [];// [{"id":0, "name": i18n.t('GENERAL.ALL')}];
                        let temp_data = {};
                        let user_data = response.data.userList;
                        user_data.filter(el => {
                            temp_data = {};
                            if(el.is_active == true){
                                temp_data['id'] = el.id;
                                temp_data['name'] = el.last_name+' '+el.first_name;
                                temp_arr.push(temp_data);
                            }
                        });
                        // 下拉選單依名稱 A-Z 排序（不分大小寫）
                        temp_arr.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
                        this.user_list = temp_arr
                    }
                }).catch((response) => {
                    this.showErrorDialog(response);
                });
            },
    async getUpGPTGroupListData(){
                await PermissionService.getUpGPTGroups().then(response => {
                    let temp_group_list = [];// [{"id":0, "name": i18n.t('GENERAL.ALL')}];
                    if (response.data.length > 0) {
                        let temp_datas = response.data;
                        for(let index in temp_datas){
                            if((temp_datas[index]['permission_type'] == "UPGPT")){
                                temp_group_list.push(temp_datas[index])
                            }
                        }
                    }
                    temp_group_list.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
                    for(let index in temp_group_list){
                        this.upgpt_group_list.push(temp_group_list[index])
                    }
                }).catch((response) => {
                    this.showErrorDialog(response);
                });
            },
    validateForm() {
      return !!this.$refs.form.validate();
    },
    onCancel() {     
      this.$emit("emitEditFolderDialog", false);
    },
    async onEdit(){
      this.messageApply = i18n.t("GPT_KNOWLEDGE.UPDATE_FOLDER_PERMISSION");

      this.messageApplyDialog = true;
    },
    async onConfirm(val) {
      // 假設你有這些狀態/欄位：this.editingFolderId、this.form、this.permissionForm
      // 依你的實際命名自行對應即可
      let msg = true;
      const folderId = this.folder.id;
      if (!folderId) return;

      const toIdObjects = (arr) =>
        (arr || [])
          .filter((x) => x !== null && x !== undefined)
          .map((x) => (typeof x === 'object' ? { id: x.id } : { id: x }));
      if(this.addFolderData.parent_id == "Root"){
        this.addFolderData.parent_id = null;
      }
      const data = {
        name: this.addFolderData?.name ?? '',
        // system_name: this.form?.system_name ?? '',
        parent_folder: this.addFolderData.parent_id,
        is_inherit: val,
        permission: {
          only_admin_user_manager: this.default_manager_access_option,
          all_allow_user_viewer:   this.default_viewer_access_option,
          only_admin_group_manager: this.default_manager_access_option,
          all_allow_group_viewer: this.default_viewer_access_option,
          user_managers: toIdObjects(this.MUData),
          user_viewers: toIdObjects(this.VUData),
          group_managers: toIdObjects(this.MGData),
          group_viewers: toIdObjects(this.VGData),
        },
      };
      await KnowledgeLibraryService.updateFolder(folderId, data).then(
          (response) => {
            if(response.data == "same name block"){
              msg = i18n.t('ADD_KNOWLEDGE_FOLDER.ERROR_3');
            }
          }
      ).catch((response) => {
            const status = response?.response?.status;
            if(status === 400){
              msg = i18n.t('ADD_KNOWLEDGE_FOLDER.ERROR_2')
            }
            else{
              this.showErrorDialog(response);
            }
        })
      this.$emit('emitEditFolderDialog', msg);
    },
    toggleManagerAccessOption(){
      if(this.default_manager_access_option){
        this.MUData = [];
        this.MGData = [];
      }
    },
    toggleViewerAccessOption(){
      if(this.default_viewer_access_option){
          this.VUData = [];
          this.VGData = [];
      }
    },
      toggle(type) {
      this.$nextTick(() => {
          if(type == "MU"){
              if (this.checkAll(this.MUData, this.user_list)) {
                  this.MUData = []
              } else {
                  this.MUData = this.user_list.slice()
              }
          }else if(type == "MG"){
              if (this.checkAll(this.MGData, this.upgpt_group_list)) {
                  this.MGData = []
              } else {
                  this.MGData = this.upgpt_group_list.slice()
              }
          }else if(type == "VU"){
              if (this.checkAll(this.VUData, this.user_list)) {
                  this.VUData = []
              } else {
                  this.VUData = this.user_list.slice()
              }
          }else if(type == "VG"){
              if (this.checkAll(this.VGData, this.upgpt_group_list)) {
                  this.VGData = []
              } else {
                  this.VGData = this.upgpt_group_list.slice()
              }
          }
      })
    },
    checkAll(selected_option, option_list){
      return selected_option.length === option_list.length
    },
    checksome(selected_option, option_list){
      return selected_option.length > 0 && !this.checkAll(selected_option, option_list)
    },
    icon(selected_option, option_list){
      if (this.checkAll(selected_option, option_list)){
          return 'mdi-close-box'
      }else if(this.checksome(selected_option, option_list)){
            return 'mdi-minus-box'
      }else{
          return 'mdi-checkbox-blank-outline'
      }
    },
    onFolderPickerCancel() {
      this.folderPickerDialog = false;
    },
    onFolderPickerConfirm({ id, path }) {
      this.addFolderData.parent_id = id;   // 回填選到的位置 id
      this.addFolderData.path = path;
      this.folderPickerDialog = false;
    },
    onEmitMessageDialog() { 
      this.messageDialog = false;
    },
    onEmitMessageApplyDialog(val) {
      this.messageApplyDialog = false;
      //  如果選擇原本的位置Path，會跳dialog 阻擋存取
      if(this.folder.id == this.addFolderData.parent_id){
        this.showErrorDialog(i18n.t('ADD_KNOWLEDGE_FOLDER.ERROR_1'));
      }else{
        this.onConfirm(val);
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    openFolderPick(){
      this.folderPickerDialog = true;
    },
    async getPermissionData(){
       let data = {
          "folder_id":this.folder.id,
       }
       await KnowledgeLibraryService.getFolderPermission(data).then(response => {
          let permissions = response.data;
          let only_admin_user_manager = permissions['only_admin_user_manager']
          let all_allow_user_viewer = permissions['all_allow_user_viewer']
          if (only_admin_user_manager){
              this.default_manager_access_option = true;
              this.ori_manager_access_option = true;
          }
          else
          {
              this.default_manager_access_option = false;
              this.ori_manager_access_option = false;
          }
          if (all_allow_user_viewer)
          {
              this.default_viewer_access_option = true;
              this.ori_viewer_access_option = true;
          }
          else{
              this.default_viewer_access_option = false;
              this.ori_viewer_access_option = false;
          }
          this.MUData = permissions['user_managers'];
          this.MGData = permissions['group_managers'];
          this.VUData = permissions['user_viewers'];
          this.VGData = permissions['group_viewers'];
          this.originalMUData = this.MUData;
          this.originalMGData = this.MGData;
          this.originalVUData = this.VUData;
          this.originalVGData = this.VGData;
        }).catch((response) => {
            this.showErrorDialog(response);
        });
    },
    cancelEdit(){
        this.default_manager_access_option = this.ori_manager_access_option;
        this.default_viewer_access_option = this.ori_viewer_access_option;
        this.MUData = this.originalMUData;
        this.MGData = this.originalMGData;
        this.VUData = this.originalVUData;
        this.VGData = this.originalVGData;
        this.$emit('emitEditFolderDialog', false);
    },
  }
})
</script>